/* eslint-disable no-console */
import { useQuery } from 'react-query'
import { useMemo } from 'react'
import { listStores } from '@lib/axios/store'
import useQueryString from '@hooks/useQueryString'

function useIndex() {
  const { params } = useQueryString()
  const { status, data } = useQuery(
    ['saas-store', params],
    () => listStores(params),
    {
      retry: false,
      staleTime: Infinity,
      keepPreviousData: true,
    }
  )
  // prettier-ignore
  const tableData = useMemo(
    () => (status === 'success' && Array.isArray(data?.data?.data)
      ? data?.data?.data
      : []),
    [status, data]
  )

  const emptyPagination = useMemo(
    () => ({
      current_page: 1,
      first_page: true,
      last_page: false,
      next_page: null,
      prev_page: null,
      total_pages: 1,
    }),
    []
  )

  // prettier-ignore
  const tablePagination = useMemo(
    () => (status === 'success' && data?.data?.pagination
      ? data?.data?.pagination
      : emptyPagination),
    [status, data, emptyPagination]
  )

  const columns = [
    ['id', 'ID', true],
    ['name', 'Nama Toko', false],
    ['owner_name', 'Nama User', false],
    ['email', 'Email', false],
    ['package', 'Paket', false],
    ['affiliate_info', 'Nama Affiliate', false],
    ['status', 'Status', true],
  ]

  const tableColumns = columns
    .map(([column, title]) => [column, title])
    .map(([accessor, Header]) => ({ accessor, Header }))

  const hiddenColumns = columns
    .filter(([, , hidden]) => hidden)
    .map(([column]) => column)

  return {
    tableData,
    tableColumns,
    hiddenColumns,
    tablePagination,
  }
}

export default useIndex
